<template>
  <section v-lenis-scroll class="gift-guide-right-collection">
    <div class="giftGuideCollectionRight">
      <div class="giftGuideCollectionRightinner">
        <div class="giftGuideCollectionRightbg">
          <div class="giftGuideBanner">
            <img
              v-lazy="giftPageData.desktopLeftImage"
              class="giftGuideBannerLeftImage"
              :alt="giftPageData.desktopLeftImage.alt"
              loading="lazy"
              aria-hidden="true"
              aria-label="Gift Guide Right Collection Image"
              width=""
              height=""
            />
            <img
              v-lazy="giftPageData.desktopRightImage"
              class="giftGuideBannerRightImage"
              :alt="giftPageData.desktopRightImage.alt"
              loading="lazy"
              aria-hidden="true"
              aria-label="Gift Guide Right Collection Image"
              width=""
              height=""
            />
          </div>
          <div class="giftGuideBannerMob">
            <img
              v-lazy="giftPageData.mobImage"
              class="giftGuideBannerMobImage"
              :alt="giftPageData.mobImage.alt"
              loading="lazy"
              aria-hidden="true"
              aria-label="Gift Guide Right Collection Image"
              width=""
              height=""
            />
          </div>
        </div>
      </div>
      <div>
        <div class="giftGuideCollectionRightscrollres">
          <h2 class="giftGuideCollectionRightscrolltextres">
            <span>{{ giftPageData.secTitle }}</span>
          </h2>
        </div>
        <div class="giftGuideCollectionRightproducts">
          <div />
          <div class="giftGuideCollectionRightinnergrid tharProducts">
            <div v-for="(value, key) in giftPageData.productData" :key="key" class="grid_item">
              <a
                v-if="value.showCollection == 'true'"
                :href="value.collectionLink"
                class="product_link"
              >
                <div
                  class="tharProductInfo"
                  :class="value.showPreview === 'true' ? 'customImage' : ''"
                >
                  <h1 class="tharProductTitle">{{ value.product.productTitle }}</h1>
                  <div class="tharProductPriceInfo">
                    <span v-if="value.product.compare_at_price > '1'" class="tharProductPrice">
                      <del>
                        {{ currencySymbol }}
                        {{ value.product.compare_at_price }}
                      </del>
                    </span>
                    <span v-if="value.product.productidPrice" class="tharProductPrice">
                      {{ currencySymbol }}
                      {{ value.product.productidPrice }}
                    </span>
                    <span
                      v-if="value.product.compare_at_price > '1'"
                      class="discountPercentage tharProductPrice"
                    >
                      {{ value.product.discount_percentage }}
                    </span>
                  </div>
                </div>
                <div class="grid_item_img">
                  <img
                    v-lazy="
                      value.showPreview == 'true'
                        ? value.previewimage
                        : value.product.productidImage
                    "
                    :alt="
                      value.showPreview === 'true' ? 'Preview Image' : value.product.productTitle
                    "
                  />
                </div>
              </a>

              <a
                v-else
                :href="value.product.productUrl"
                :product-id="value.product.productid"
                class="product_link"
              >
                <div
                  class="tharProductInfo"
                  :class="value.showPreview === 'true' ? 'customImage' : ''"
                >
                  <div v-if="value.showPrice == 'true'">
                    <h1 class="tharProductTitle">{{ value.product.productTitle }}</h1>
                    <div class="tharProductPriceInfo">
                      <span v-if="value.product.compare_at_price > '1'" class="tharProductPrice">
                        <del>
                          {{ currencySymbol }}
                          {{ value.product.compare_at_price }}
                        </del>
                      </span>
                      <span v-if="value.product.productidPrice" class="tharProductPrice">
                        {{ currencySymbol }}
                        {{ value.product.productidPrice }}
                      </span>
                      <span
                        v-if="value.product.compare_at_price > '1'"
                        class="discountPercentage tharProductPrice"
                      >
                        {{ value.product.discount_percentage }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="grid_item_img">
                  <img
                    v-lazy="
                      value.showPreview == 'true'
                        ? value.previewimage
                        : value.product.productidImage
                    "
                    :alt="
                      value.showPreview === 'true' ? 'Preview Image' : value.product.productTitle
                    "
                    loading="lazy"
                    aria-hidden="true"
                    aria-label="Gift Guide Right Collection Image"
                    width=""
                    height=""
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { currencyJson } from '@/currency';

export default {
  props: {
    giftPageData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      currencySymbol: currencyJson[window?.Shopify?.currency?.active]?.symbol_native,
    };
  },
  computed: {
    backgroundImage() {
      return this.windowWidth <= 768 ? this.giftPageData.mobBg : this.giftPageData.desktopBg;
    },
  },
  mounted() {
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native;
    this.handleResize = () => {
      this.windowWidth = window.innerWidth;
    };
    window.addEventListener('resize', this.handleResize);

    gsap.registerPlugin(ScrollTrigger);
    const mm = gsap.matchMedia();

    mm.add('(max-width: 768px)', () => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.giftGuideCollectionRightinnergrid',
          start: 'top 95%',
          end: '80% top',
          scrub: true,
        },
      });

      tl.fromTo('.giftGuideBannerMobImage', { scale: 1 }, { scale: 1.3 });
    });

    mm.add('(min-width: 769px)', () => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.giftGuideCollectionRightinner',
            scrub: 2,
            start: 'top bottom',
            end: '100% center',
            // markers: true
          },
        })
        .to(
          '.giftGuideCollectionRightinner',
          {
            position: 'sticky',
            top: 0,
          },
          'b'
        )
        .to(
          '.giftGuideCollectionRightscroll',
          {
            xPercent: -50,
          },
          'b'
        );
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
.tharProductTitle,
.tharProductPrice {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 12.08px;
  font-weight: 400;
  line-height: 10.99px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #000;
}

.giftGuideBanner {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.giftGuideBannerMob {
  display: none;
  overflow: hidden;
}

.tharProductPriceInfo {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}

.discountPercentage {
  color: red;
}

.tharProductPrice {
  font-weight: 700;
}

.tharProductInfo.customImage * {
  color: #ffff;
}

.tharProductInfo.customImage .discountPercentage {
  color: red;
}

.tharProductInfo.customImage .tharProductPrice del {
  color: grey;
}

.tharProducts .grid_item {
  position: relative;
}

.grid_item .tharProductInfo {
  position: absolute;
  bottom: 12px;
  left: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.giftGuideCollectionRightscrolltext {
  /* font-family: Neue Haas Grotesk Display Pro; */
  max-width: 320px;
  width: 100%;
  margin: 30px 96px 0 0;
}

.giftGuideCollectionRightscrolltext span {
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 18.2px;
  text-transform: uppercase;
  text-align: right;
  display: block;
}

.giftGuideCollectionRightinnergrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background-color: #f0f1f4;
}

.giftGuideCollectionRightinnergrid img {
  width: 100%;
  height: 100%;
  display: block;
}

.giftGuideCollectionRightinner {
  position: relative;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

.giftGuideCollectionRightproducts {
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  position: relative;
  z-index: 4;
}

.giftGuideCollectionRightscroll {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  text-align: center;
  height: 100vh;
  margin: 0 auto;
}

.giftGuideCollectionRightscrolltextres {
  display: none;
}

@media screen and (max-width: 1024px) {
  .giftGuideCollectionRightscrolltext {
    margin: 30px 25px 0 0;
  }
}

@media only screen and (max-width: 768px) {
  .giftGuideCollectionRightbg {
    width: 100%;
    max-width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
  }

  .giftGuideBanner {
    display: none;
  }
  .giftGuideBannerMob {
    display: block;
  }

  .giftGuideCollectionRightscrolltext {
    margin: 0px;
  }

  .giftGuideCollectionRightscroll {
    text-align: center;
    align-items: center;
    display: none;
  }

  .giftGuideCollectionRightinner {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }

  .giftGuideCollectionRightproducts {
    grid-template-columns: 0% 100%;
  }

  .giftGuideCollectionRightinnergrid {
    width: 100%;
  }

  .giftGuideCollectionRightscrolltextres {
    display: block;
    /* font-family: Neue Haas Grotesk Display Pro; */
    max-width: 320px;
    width: 100%;
    padding: 20px 0;
  }

  .giftGuideCollectionRightscrolltextres span {
    font-size: 14px;
    font-weight: 400;
    line-height: 18.2px;
    color: #ffffff;
    text-align: center;
    text-transform: uppercase;
    display: block;
  }

  .giftGuideCollectionRightscrollres {
    position: -webkit-sticky;
    position: sticky;
    top: 0%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tharProductTitle,
  .tharProductPrice {
    font-size: 8px;
    line-height: 1;
    letter-spacing: 0.01em;
  }

  .grid_item .tharProductInfo {
    bottom: 2px;
    left: 2px;
    padding: 5px;
  }
}
</style>
